export const ArrowLeft = ({
  color = "light-dark(#6c757d, #ffffff)",
  width = 16,
  height = 16,
  ...props
}) => {
  return (
    <svg
      {...props}
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 11.0397C10 11.4442 9.54466 11.6813 9.21327 11.4493L5.58517 8.90962C5.30081 8.71057 5.30081 8.28943 5.58517 8.09038L9.21327 5.55071C9.54466 5.31874 10 5.55582 10 5.96033V11.0397Z"
        fill={color}
      />
    </svg>
  )
}

export const ArrowRight = ({
  color = "light-dark(#6c757d, #ffffff)",
  width = 16,
  height = 16,
  ...props
}) => {
  return (
    <svg
      {...props}
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 4.96033C6 4.55582 6.45534 4.31874 6.78673 4.55071L10.4148 7.09038C10.6992 7.28943 10.6992 7.71057 10.4148 7.90962L6.78673 10.4493C6.45534 10.6813 6 10.4442 6 10.0397V4.96033Z"
        fill={color}
      />
    </svg>
  )
}

export const ArrowUp = ({
  color = "light-dark(#6c757d, #ffffff)",
  width = 16,
  height = 16,
  ...props
}) => {
  return (
    <svg
      {...props}
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.96033 10.5C4.55582 10.5 4.31874 10.0447 4.55071 9.71327L7.09038 6.08517C7.28943 5.80081 7.71057 5.80081 7.90962 6.08517L10.4493 9.71327C10.6813 10.0447 10.4442 10.5 10.0397 10.5H4.96033Z"
        fill={color}
      />
    </svg>
  )
}

export const ArrowDown = ({
  color = "light-dark(#6c757d, #ffffff)",
  width = 16,
  height = 16,
  ...props
}) => {
  return (
    <svg
      {...props}
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0397 6C11.4442 6 11.6813 6.45534 11.4493 6.78673L8.90962 10.4148C8.71057 10.6992 8.28943 10.6992 8.09038 10.4148L5.55071 6.78673C5.31874 6.45534 5.55582 6 5.96033 6H11.0397Z"
        fill={color}
      />
    </svg>
  )
}

export const Plus = ({
  color = "light-dark(#6c757d, #ffffff)",
  width = 16,
  height = 16,
  ...props
}) => {
  return (
    <svg
      {...props}
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 8C14 8.13261 13.9473 8.25979 13.8536 8.35355C13.7598 8.44732 13.6326 8.5 13.5 8.5H8.5V13.5C8.5 13.6326 8.44732 13.7598 8.35355 13.8536C8.25979 13.9473 8.13261 14 8 14C7.86739 14 7.74021 13.9473 7.64645 13.8536C7.55268 13.7598 7.5 13.6326 7.5 13.5V8.5H2.5C2.36739 8.5 2.24021 8.44732 2.14645 8.35355C2.05268 8.25979 2 8.13261 2 8C2 7.86739 2.05268 7.74021 2.14645 7.64645C2.24021 7.55268 2.36739 7.5 2.5 7.5H7.5V2.5C7.5 2.36739 7.55268 2.24021 7.64645 2.14645C7.74021 2.05268 7.86739 2 8 2C8.13261 2 8.25979 2.05268 8.35355 2.14645C8.44732 2.24021 8.5 2.36739 8.5 2.5V7.5H13.5C13.6326 7.5 13.7598 7.55268 13.8536 7.64645C13.9473 7.74021 14 7.86739 14 8Z"
        fill={color}
      />
    </svg>
  )
}

export const Image = ({
  color = "light-dark(#6c757d, #ffffff)",
  width = 16,
  height = 16,
  ...props
}) => {
  return (
    <svg
      {...props}
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5 2.5H2.5C2.23478 2.5 1.98043 2.60536 1.79289 2.79289C1.60536 2.98043 1.5 3.23478 1.5 3.5V12.5C1.5 12.7652 1.60536 13.0196 1.79289 13.2071C1.98043 13.3946 2.23478 13.5 2.5 13.5H13.5C13.7652 13.5 14.0196 13.3946 14.2071 13.2071C14.3946 13.0196 14.5 12.7652 14.5 12.5V3.5C14.5 3.23478 14.3946 2.98043 14.2071 2.79289C14.0196 2.60536 13.7652 2.5 13.5 2.5ZM13.5 3.5V9.92188L11.8706 8.29313C11.7778 8.20024 11.6675 8.12656 11.5462 8.07629C11.4248 8.02602 11.2948 8.00015 11.1634 8.00015C11.0321 8.00015 10.902 8.02602 10.7807 8.07629C10.6594 8.12656 10.5491 8.20024 10.4563 8.29313L9.20625 9.54313L6.45625 6.79313C6.26873 6.60573 6.01448 6.50046 5.74937 6.50046C5.48427 6.50046 5.23002 6.60573 5.0425 6.79313L2.5 9.33562V3.5H13.5ZM2.5 10.75L5.75 7.5L10.75 12.5H2.5V10.75ZM13.5 12.5H12.1644L9.91438 10.25L11.1644 9L13.5 11.3363V12.5ZM9 6.25C9 6.10166 9.04399 5.95666 9.1264 5.83332C9.20881 5.70999 9.32594 5.61386 9.46299 5.55709C9.60003 5.50032 9.75083 5.48547 9.89632 5.51441C10.0418 5.54335 10.1754 5.61478 10.2803 5.71967C10.3852 5.82456 10.4566 5.9582 10.4856 6.10368C10.5145 6.24917 10.4997 6.39997 10.4429 6.53701C10.3861 6.67406 10.29 6.79119 10.1667 6.8736C10.0433 6.95601 9.89834 7 9.75 7C9.55109 7 9.36032 6.92098 9.21967 6.78033C9.07902 6.63968 9 6.44891 9 6.25Z"
        fill={color}
        fillOpacity="0.5"
      />
    </svg>
  )
}

export const VerticalDots = ({
  color = "light-dark(#6c757d, #ffffff)",
  width = 16,
  height = 16,
  ...props
}) => {
  return (
    <svg
      {...props}
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 8C14 8.39556 13.8874 8.78224 13.6764 9.11114C13.4654 9.44004 13.1656 9.69638 12.8148 9.84776C12.4639 9.99913 12.0779 10.0387 11.7054 9.96157C11.333 9.8844 10.9909 9.69392 10.7224 9.41421C10.4538 9.13451 10.271 8.77814 10.1969 8.39018C10.1228 8.00222 10.1608 7.60009 10.3062 7.23463C10.4515 6.86918 10.6976 6.55682 11.0133 6.33706C11.329 6.1173 11.7003 6 12.08 6C12.5892 6 13.0776 6.21071 13.4376 6.58579C13.7977 6.96086 14 7.46957 14 8ZM3.92 6C3.54026 6 3.16905 6.1173 2.85331 6.33706C2.53756 6.55682 2.29147 6.86918 2.14615 7.23463C2.00083 7.60009 1.96281 8.00222 2.03689 8.39018C2.11098 8.77814 2.29384 9.13451 2.56236 9.41421C2.83087 9.69392 3.17298 9.8844 3.54543 9.96157C3.91787 10.0387 4.30392 9.99913 4.65475 9.84776C5.00559 9.69638 5.30545 9.44004 5.51642 9.11114C5.72739 8.78224 5.84 8.39556 5.84 8C5.84 7.46957 5.63772 6.96086 5.27765 6.58579C4.91758 6.21071 4.42922 6 3.92 6Z"
        fill={color}
      />
    </svg>
  )
}

export const Download = ({
  color = "light-dark(#6c757d, #ffffff)",
  width = 16,
  height = 16,
  ...props
}) => {
  return (
    <svg
      {...props}
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 9V13C14 13.1326 13.9473 13.2598 13.8536 13.3536C13.7598 13.4473 13.6326 13.5 13.5 13.5H2.5C2.36739 13.5 2.24021 13.4473 2.14645 13.3536C2.05268 13.2598 2 13.1326 2 13V9C2 8.86739 2.05268 8.74021 2.14645 8.64645C2.24021 8.55268 2.36739 8.5 2.5 8.5C2.63261 8.5 2.75979 8.55268 2.85355 8.64645C2.94732 8.74021 3 8.86739 3 9V12.5H13V9C13 8.86739 13.0527 8.74021 13.1464 8.64645C13.2402 8.55268 13.3674 8.5 13.5 8.5C13.6326 8.5 13.7598 8.55268 13.8536 8.64645C13.9473 8.74021 14 8.86739 14 9ZM7.64625 9.35375C7.69269 9.40024 7.74783 9.43712 7.80853 9.46228C7.86923 9.48744 7.93429 9.50039 8 9.50039C8.06571 9.50039 8.13077 9.48744 8.19147 9.46228C8.25217 9.43712 8.30731 9.40024 8.35375 9.35375L10.8538 6.85375C10.9002 6.8073 10.9371 6.75214 10.9622 6.69145C10.9873 6.63075 11.0003 6.5657 11.0003 6.5C11.0003 6.4343 10.9873 6.36925 10.9622 6.30855C10.9371 6.24786 10.9002 6.1927 10.8538 6.14625C10.8073 6.09979 10.7521 6.06294 10.6914 6.0378C10.6308 6.01266 10.5657 5.99972 10.5 5.99972C10.4343 5.99972 10.3692 6.01266 10.3086 6.0378C10.2479 6.06294 10.1927 6.09979 10.1462 6.14625L8.5 7.79313V2C8.5 1.86739 8.44732 1.74021 8.35355 1.64645C8.25979 1.55268 8.13261 1.5 8 1.5C7.86739 1.5 7.74021 1.55268 7.64645 1.64645C7.55268 1.74021 7.5 1.86739 7.5 2V7.79313L5.85375 6.14625C5.75993 6.05243 5.63268 5.99972 5.5 5.99972C5.36732 5.99972 5.24007 6.05243 5.14625 6.14625C5.05243 6.24007 4.99972 6.36732 4.99972 6.5C4.99972 6.63268 5.05243 6.75993 5.14625 6.85375L7.64625 9.35375Z"
        fill={color}
      />
    </svg>
  )
}
